/* Phone-only Shopify Inbox activator treatment. The chat panel and its native
   click behavior remain untouched; only the visible launcher is replaced. */
(() => {
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return

  const findActivatorRoot = (node) => {
    if (!node || !node.shadowRoot) return null
    const root = node.shadowRoot
    if (root.querySelector('.activator')) return root
    for (const child of root.querySelectorAll('*')) {
      const found = findActivatorRoot(child)
      if (found) return found
    }
    return null
  }

  const applyQuestionActivator = () => {
    const host = document.querySelector('shopify-chat, shopify-agent')
    const root = findActivatorRoot(host)
    if (!root || root.querySelector('[data-mobile-question-activator]')) return false

    const activator = root.querySelector('.activator')
    const icon = root.querySelector('.activator__icon')
    if (!activator || !icon) return false

    const style = document.createElement('style')
    style.setAttribute('data-mobile-question-activator', '')
    style.textContent = `
      .activator { --activator-fg: #ffffff !important; --activator-bg: #ed746e !important; width: 48px !important; height: 48px !important; border-radius: 50% !important; }
      .activator__icon { width: 24px !important; height: 24px !important; color: #ffffff !important; display: grid !important; place-items: center !important; }
      .activator__icon > * { display: none !important; }
      .activator__icon::after { content: '?'; display: block; color: #ffffff; font: 600 24px/1 Arial, sans-serif; }
    `
    root.append(style)
    return true
  }

  const timer = window.setInterval(() => {
    if (applyQuestionActivator()) window.clearInterval(timer)
  }, 100)
  window.setTimeout(() => window.clearInterval(timer), 10000)
})()
